/**
 * プロジェクトのスラッグの変更の英語の文言（2026-09-28 creator/slug-rename）。en.ts が `...enSlug` で取り込む（ja.slug.ts が同じキーを全部持つことを型で強制）。
 * 使う画面: components/SlugSettings.tsx・SlugChangeDialog.tsx・OldSlugsList.tsx（ホスティングの画面の「URL スラッグ」）。
 *
 * 料金の書き方（founder の決定 2026-09-28）: 古い URL の転送は 1 つにつき月 {price}・日割りで前払いから。金額は {price} で差し込む
 *   （サーバーの値。直書きしない = slugRename.ts の redirectMonthlyUsd）。「残す / 残さない」は並べて見せ、既定の選択は置かない。
 * 送信元の文言は Core の案（一度でもメールを送ったプロジェクトは元の名前に固定 = 到達率のため）に合わせる。
 */
export const enSlug = {
  'slug.title': 'Name in your web address',
  'slug.lead': 'The name that goes in your app’s web address (now the “{slug}” part). You can change it once every {days} days.',
  // 間隔が 1 日のとき（2026-10-04 から）。「once every 1 days」と出さない（slugRename.ts の slugLeadMessage）
  'slug.leadDaily': 'The name that goes in your app’s web address (now the “{slug}” part). You can change it once a day.',
  'slug.change': 'Change the name',
  'slug.nextChangeAt': 'You can change it again on {date}.',
  'slug.undo': 'Undo the last change (back to {slug})',
  'slug.undoNote': 'Until {date}. Undoing does not count toward the limit.',
  'slug.changed': 'The name in your web address is now “{slug}”.',
  'slug.changedRedirect': 'Links that use {old} now go to the new URL.',
  'slug.changedNoRedirect': 'Links that use {old} now show "Not found".',
  'slug.tooSoon': 'You changed the name in your web address recently. You can change it again on {date}.',
  'slug.accountClosed': 'This account is closed, so the name in your web address cannot be changed.',

  // 入力と確認（SlugChangeDialog.tsx）
  'slug.dialog.title': 'Change the name in your web address',
  'slug.dialog.newSlug': 'New name (the “neko-jump” kind of part in the address)',
  'slug.dialog.hint': '3–58 characters: lowercase letters, digits and hyphens.',
  'slug.dialog.check': 'Check if it is available',
  'slug.dialog.suggestions': 'Free right now. Pick one to check it:',
  'slug.confirm.title': 'Change {old} to {new}?',
  'slug.confirm.undoTitle': 'Undo: change {old} back to {new}?',
  'slug.confirm.urlsBefore': 'Now',
  'slug.confirm.urlsAfter': 'After the change',
  'slug.confirm.customDomains': 'Your custom domains (your own domains) do not change.',
  'slug.confirm.oldLinks': 'What should happen to links that use {old}? Choose one.',
  'slug.choice.keep': 'Keep old links working (redirect to the new URL)',
  'slug.choice.keepCost': '{price} a month for this old name, charged daily from your prepaid balance while the redirect is on. Turn it off any time.',
  'slug.choice.keepCostMonthly': '{price} a month for this old name, from your prepaid balance while the redirect is on. Turn it off any time.',
  'slug.choice.keepCostUnknown': 'Charged from your prepaid balance while the redirect is on. Turn it off any time.',
  'slug.choice.drop': 'Let old links stop working',
  'slug.choice.dropNote': 'Old links show "Not found". No charge. The old name stays reserved for you, so you can turn the redirect on later.',
  'slug.choice.required': 'Choose what happens to the old links to continue.',
  'slug.confirm.limit': 'After this change, you can change the name again on {date}.',
  'slug.confirm.undo': 'This undoes your last change, so it does not count toward the limit.',
  'slug.confirm.noCount': 'This change does not count toward the limit.',
  'slug.confirm.mailPinned': 'Your mail sender stays {address}: this project has already sent mail, and keeping the name protects delivery.',
  'slug.confirm.mailChanges': 'Your mail sender changes from {before} to {after}.',
  'slug.confirm.unsubscribe': 'Unsubscribe links in mail you already sent keep working.',
  'slug.confirm.reauth': 'Next, you will be asked to confirm it is you.',
  'slug.confirm.submit': 'Change the name',
  'slug.confirm.back': 'Back',

  // 古いスラッグの一覧と転送の ON / OFF（OldSlugsList.tsx）
  'slug.old.title': 'Names you used before',
  'slug.old.lead': 'Names you used before stay reserved for you while this project exists: nobody else can take them (30 days after you delete the project, they are free again). Choose here whether old links go on to your current address.',
  'slug.old.redirecting': 'Redirecting',
  'slug.old.notFound': 'Shows "Not found"',
  'slug.old.retired': 'Used until {date}',
  'slug.old.perMonth': '{price}/month',
  'slug.old.turnOn': 'Turn redirect on',
  'slug.old.turnOff': 'Turn redirect off',
  'slug.old.onTitle': 'Redirect {old} to the current URL?',
  'slug.old.offTitle': 'Stop redirecting {old}?',
  'slug.old.offBody': 'Links that use {old} will show "Not found", and the charge for this redirect stops. The old name stays reserved for you, so you can turn it on again later.',
  'slug.old.updatedOn': '{old} now redirects to the current URL.',
  'slug.old.updatedOff': '{old} no longer redirects.',

  // サーバーのエラー（errorText が `error.<code>` を引く）
  'error.redirect_choice_required': 'Choose whether old links keep working (redirect) or stop working.',
  'error.slug_unchanged': 'That is already the name in your web address.',
  'error.slug_change_too_soon': 'You changed the name in your web address recently. Try again later.',
  'error.old_slug_not_found': 'That old name was not found. Reload the page.'
} satisfies Record<string, string>;
